import React from 'react'
import {HashRouter, Route, Routes} from 'react-router-dom'

import Ingreso from './components/ingreso.component'

interface Props{}

interface State{}

class App extends React.Component<Props,State>{
    constructor(props:Props){
        super(props)
        this.state = {}
    }   

    render(): React.ReactNode {
        return(
            <HashRouter>
                <div className='main-masterplan-page'>
                    <Routes>
                        <Route path="/" element={<Ingreso/>}/>
                    </Routes>
                </div>
            </HashRouter>
        )
    }
}

export default App